import React from 'react'
import { SvgIcon } from '@mui/material'
import { ReactComponent as Welcome2Icon } from 'assets/icons/Welcome2.svg'
import RatingBarChart from 'pages/Dashboard/RatingBarChart'

// פאנל צד לעמוד הפתיחה — כרטיס "דירוגי הקריאה של כלל התלמידים",
// אותו כרטיס שמוצג למשתמשים רגילים בדשבורד. בורר שנה/סמסטר עבר לכותרת המצגת (PresentationViewer)
const RatingSidePanel = () => (
    <div className='rating-side'>
        <div className='wrap-card-title'>
            <div className='card-title'>
                <SvgIcon component={Welcome2Icon} inheritViewBox />
                {'דירוגי הקריאה של כלל התלמידים'}
            </div>
        </div>
        <RatingBarChart compact />
    </div>
)

export default RatingSidePanel
